// @flow

import styles from './ApplyButtonCard.less';

import React, { PureComponent } from 'react';

import { Section, Hidden, Card } from 'seek-style-guide/react';
import JobApplyMessage from '../JobApplyMessage/JobApplyMessage';
import ApplyButton from '../ApplyButton/ApplyButton';
import SaveJob from 'src/components/SaveJob/SaveJob';

import Sticky from 'react-sticky-el';

type ApplyButtonCardProps = {
  appliedDateUTC?: string,
  isExpired?: boolean,
  isApplied: boolean,
  isLinkOut: boolean,
  jobId: number,
  isScreenAssigned?: boolean,
  isSelectionCriteriaEnabled?: boolean
};

class ApplyButtonCard extends PureComponent<ApplyButtonCardProps> {
  static defaultProps = {
    isLinkOut: false,
    isScreenAssigned: false,
    isSelectionCriteriaEnabled: false
  };

  render() {
    const {
      isLinkOut,
      isExpired,
      isApplied,
      isScreenAssigned,
      isSelectionCriteriaEnabled,
      appliedDateUTC,
      jobId
    } = this.props;

    const showApplyMessage =
      isApplied || isLinkOut || isScreenAssigned || isSelectionCriteriaEnabled;

    return (
      <Card>
        <Hidden
          className={styles.section}
          component={Section}
          mobile={!showApplyMessage}
        >
          {!isExpired && (
            <Hidden mobile>
              <div className={styles.stickyApplyPlaceholder}>
                <Sticky topOffset={-9} stickyClassName={styles.whenSticky}>
                  <div className={styles.applyButtonContainer}>
                    <ApplyButton />
                    {!isApplied && (
                      <SaveJob
                        job={{ id: jobId }}
                        className={styles.stickySave}
                      />
                    )}
                  </div>
                </Sticky>
              </div>
            </Hidden>
          )}
          {showApplyMessage && (
            <JobApplyMessage
              {...{
                isLinkOut,
                appliedDateUTC,
                isScreenAssigned,
                isSelectionCriteriaEnabled
              }}
            />
          )}
        </Hidden>
      </Card>
    );
  }
}

export default ApplyButtonCard;
